import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/opt/render/project/src/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/Footer/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/Header/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/HeaderInquiryForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/InitEffects.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/InitReduxFromServer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/PageLoader/PageLoader.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/RouteLoader.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/store/Providers.jsx");
